import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { RootState } from "../_store";
import { GetCharacteristicsFromString } from "../models/product/IProductCharacteristics";
import { IProduct } from "../models/product/IProduct";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { IMAGE } from "../constants/endpoints";

export default function ProductPage() {
    const { id } = useParams();

    const [product, setProduct] = useState<IProduct>();

    const Products = useSelector((state: RootState) => state.product.products);

    useEffect(() => {
        if (id) {
            setProduct(Products.find((x: any) => x.id === Number(id)));
        }
    }, [id, Products])


    return (
        <Container className="page-container">
            {product &&
                <>
                    <Row style={{ paddingBottom: "30px", paddingTop: "30px" }}>
                        <Col>
                            <ImageGallery items={product.images?.map((image: any) => (
                                {
                                    original: `/api/${IMAGE}?id=${image}`,
                                    thumbnail: `/api/${IMAGE}?id=${image}`,
                                    originalHeight: 400
                                }))}
                                showFullscreenButton={false}
                                showPlayButton={false}
                                thumbnailPosition="left" />
                        </Col>

                        <Col className="adaptive-font-size">

                            <h4>{product.name}</h4>

                            <p className="card-description">
                                {product.description}
                            </p>
                            <p>
                                {GetCharacteristicsFromString(product.characteristics).map((c: any) => (
                                    <Row>
                                        <Col
                                            style={{
                                                fontWeight: "lighter",
                                                color: "var(--grey)",
                                                maxWidth: "200px"
                                            }}
                                            md="auto">{c.name}</Col>
                                        <Col style={{ marginBottom: "5px", borderBottom: "1px solid var(--light-grey)" }}></Col>
                                        <Col md="auto">{c.value}</Col>
                                    </Row>
                                ))}
                            </p>
                        </Col>
                    </Row>
                </>
            }


        </Container>
    )
}